<template>
  <b-col sm="12" :lg="lgSize" :offset-lg="lgOffset">
    <div class="animated fadeIn">
      <b-card class="backClass" header="Received">
        <div
          slot="header"
          style="display:flex; justify-content: space-between;"
        >
          <HeaderTitle
            title="Active Backlog"
            productGroups="true"
            productGroupsEmit="showDetails"
            @showDetails="detailView"
          ></HeaderTitle>
          <HeaderControl
            :showFullscreenIcon="true"
            :showDownloadPdfIcon="true"
            :showDownloadExcelIcon="true"
            @emit-fullscreen="toggleFullScreen"
            @emit-pdf-download="downloadPDF"
            @emit-excel-download="
              downloadExcel(
                $http,
                {},
                setLoading,
                'api/tables/downloadEntireActiveBacklog.php',
                'BacklogReport'
              )
            "
            :loadingExcel="loadingExcel"
            :loadingPdf="loadingPdf"
          ></HeaderControl>
        </div>
        <div style="margin-top: 30px" class="chart-wrapper">
          <LoadingCard v-if="loadingData"></LoadingCard>
          <highcharts
            ref="backRef"
            v-else
            :options="chartOptions"
            class="chart"
            :constructor-type="'chart'"
          ></highcharts>
        </div>
        <FooterOptions
          :showTop10="true"
          :showAll="true"
          :showOverall="true"
          :overallUrl="
            isCelia
              ? '/base/TableAllDataC?type=backlog'
              : '/base/TableAllDataPaginated?type=backlog&paginated=true'
          "
          @top-10-all-data-emit="top10AllDataEmit"
        ></FooterOptions>
      </b-card>
    </div>
  </b-col>
</template>

<script>
import { Chart } from "highcharts-vue";
import router from "../../../router";
import Highcharts from "highcharts";
import exporting from "highcharts/modules/exporting";
import HeaderTitle from "../../shared/HeaderTitle.vue";
import HeaderControl from "../../shared/HeaderControl.vue";
import FooterOptions from "../../shared/FooterOptions.vue";
import LoadingCard from "../../shared/LoadingCard.vue";
import { ActiveBacklogColumnChart } from "../../../utils/ChartProps";
import {
  isCurrentUser,
  isUserLoggedIn,
  downloadExcel
} from "../../../utils/Utils";
import Constants from "../../../utils/Constants";
exporting(Highcharts);
export default {
  name: "ActiveBacklogColumn",
  components: {
    router,
    highcharts: Chart,
    Highcharts,
    HeaderTitle,
    HeaderControl,
    FooterOptions,
    LoadingCard
  },
  props: ["lgSize", "lgOffset", "locParam", "idCity", "nameCity"],
  data: function() {
    return {
      downloadExcel: downloadExcel,
      fullscreen: false,
      city: "",
      loadingData: false,
      isCelia: false,
      loadingExcel: false,
      loadingPdf: false,
      showAll: false,
      dateTo: "",
      shippedLocation: "",
      shippedProductGroup: "",
      locationsIds: "",
      chartOptions: {}
    };
  },
  methods: {
    changeShippedLocation(newLocation) {
      this.shippedLocation = newLocation;
    },
    top10AllDataEmit(disabledAll) {
      this.showAll = disabledAll;
      this.fetchData();
    },
    detailView() {
      this.$emit("detailView");
    },
    toggleFullScreen() {
      this.$fullscreen.toggle(this.$el.querySelector(".backClass"), {
        wrap: false,
        callback: this.fullscreenChange
      });
    },
    fullscreenChange(fullscreen) {
      this.fullscreen = fullscreen;
      if (this.fullscreen) {
        this.$refs.backRef.chart.options.chart.height = "50%";
      } else {
        this.$refs.backRef.chart.options.chart.height = 400;
      }
      this.$refs.backRef.chart.reflow();
    },
    fetchData() {
      this.loadingData = true;
      let params = {};
      params = {
        chartType: "backlog"
      };
      this.$http.get("api/charts/chart_data.php", { params }).then(
        res => {
          if (!this.showAll) {
            let tmp = res.data.upData;
            tmp.sort((a, b) =>
              parseFloat(a.locationTotal) > parseFloat(b.locationTotal) ? -1 : 1
            );

            let smp = res.data.dnData;

            smp.forEach(value => {
              value.data.sort((a, b) =>
                parseInt(a[1]) > parseInt(b[1]) ? -1 : 1
              );
            });

            let newArr = tmp.slice(0, 10);

            if (this.locParam == 0) {
              if (smp.length != 0) {
                this.chartOptions.series[0].data = smp[0].data;
              }
            } else {
              this.chartOptions.series[0].data = newArr;
              this.chartOptions.drilldown.series = smp;
            }
          } else {
            let smp = res.data.dnData;
            smp.forEach(value => {
              value.data.sort((a, b) =>
                parseInt(a[1]) > parseInt(b[1]) ? -1 : 1
              );
            });
            let tmp = res.data.upData;
            tmp.sort((a, b) =>
              parseFloat(a.locationTotal) > parseFloat(b.locationTotal) ? -1 : 1
            );
            if (this.locParam == 0) {
              this.chartOptions.series[0].data = smp[0].data;
            } else {
              this.chartOptions.series[0].data = tmp;
              this.chartOptions.drilldown.series = smp;
            }
          }
          this.chartOptions.title.text = "Total units: " + res.data.totals;
          this.loadingData = false;
          setTimeout(() => {
            this.changeHeight();
          });
        },
        err => {
          this.loadingData = false;
          console.log(err);
        }
      );
    },
    changeHeight() {
      if (this.fullscreen) {
        this.$refs.backRef.chart.options.chart.height = "50%";
      } else {
        this.$refs.backRef.chart.options.chart.height = 400;
      }
      this.$refs.backRef.chart.reflow();
    },
    downloadPDF() {
      this.loadingPdf = true;
      if (this.locParam == 1) {
        this.$refs.backRef.chart.options.title.text =
          "Active Backlog | " + this.dateTo + " " + this.shippedLocation;
        this.$refs.backRef.chart.options.title.style.color = "black";
      } else {
        this.$refs.backRef.chart.options.title.text =
          "Active Backlog | " + this.dateTo + " " + this.nameCity;
        this.$refs.backRef.chart.options.title.style.color = "black";
      }
      this.$refs.backRef.chart.options.title.style.display = "block";
      this.$refs.backRef.chart.options.drilldown.activeAxisLabelStyle.color =
        "black";
      this.$refs.backRef.chart.options.xAxis.forEach(obj => {
        obj.labels.style.color = "black";
      });
      this.$refs.backRef.chart.exportChart({
        type: "application/pdf",
        filename: "ActiveBacklog-" + this.dateTo
      });
      this.$refs.backRef.chart.options.drilldown.activeAxisLabelStyle.color =
        "white";
      this.loadingPdf = false;
    },
    setLoading(loading) {
      this.loadingExcel = loading;
    }
  },
  mounted() {
    isUserLoggedIn(router);
    this.isCelia = isCurrentUser(Constants.CELIA, Constants.REACHEL);

    this.dateTo = new Date().toJSON().slice(0, 10);
    if (this.locParam == 1) {
      this.locationsIds = localStorage.getItem("locations");
    } else {
      this.locationsIds = this.idCity;
      this.city = this.nameCity + "%287%29";
    }
    this.chartOptions = ActiveBacklogColumnChart(
      router,
      this.locParam,
      this.city,
      this.locationsIds,
      this.changeShippedLocation
    );
    this.fetchData();
  }
};
</script>

<style>
/* IE fix */
#card-chart-01,
#card-chart-02 {
  width: 100% !important;
}
.highcharts-exporting-group {
  display: none !important;
}
</style>
